import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

import './style.scss'

export default class HistoryButton extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        onClickHandler: PropTypes.func,
    }

    static defaultProps = {
        onClickHandler: () => {},
    }

    onClickHandler = () => {
        const { id, onClickHandler } = this.props

        onClickHandler(id)
    }

    render() {
        return (
            <div className={cx('history-button')} onClick={this.onClickHandler}>
                <FormattedMessage
                    id={'scenes.Gnosus.components.Workspace.components.BlockTable.components.HistoryButton.history'}
                />
            </div>
        )
    }
}
